
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15 6C15 7.30622 14.1652 8.41746 13 8.8293V18.9527C15.531 18.7052 16.9788 17.5282 17.825 16.4C18.1907 15.9123 18.4515 15.4225 18.6343 15H18V13H20H21.1805L20.9864 14.1644L20 14C20.9864 14.1644 20.9863 14.165 20.9862 14.1656L20.986 14.1669L20.9855 14.1699L20.9841 14.1776L20.9801 14.1996C20.9769 14.2171 20.9724 14.2403 20.9666 14.2687C20.9549 14.3256 20.9376 14.4039 20.9135 14.5003C20.8653 14.6931 20.7894 14.9602 20.6749 15.2771C20.4469 15.9085 20.0608 16.7523 19.425 17.6C18.1268 19.3309 15.84 21 12 21C8.15999 21 5.87317 19.3309 4.575 17.6C3.93922 16.7523 3.55307 15.9085 3.32507 15.2771C3.21063 14.9602 3.13468 14.6931 3.08649 14.5003C3.06237 14.4039 3.04511 14.3256 3.03341 14.2687C3.02756 14.2403 3.02309 14.2171 3.01985 14.1996L3.01587 14.1776L3.01453 14.1699L3.01402 14.1669L3.0138 14.1656C3.0137 14.165 3.0136 14.1644 4 14L3.0136 14.1644L2.81953 13H4H5.99999V15H5.3657C5.54851 15.4225 5.80925 15.9123 6.175 16.4C7.02115 17.5282 8.46896 18.7052 11 18.9527V8.82929C9.83481 8.41745 9 7.30622 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowAnchorpointlinkFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
